// src/services/customerService.js
import axios from "axios";

const API_URL = `${process.env.REACT_APP_BASE_URL}/customers`;

export const getCustomers = async (
  page = 1,
  limit = 10,
  searchQuery = "",
  status = "Ativo"
) => {
  try {
    const response = await axios.get(API_URL, {
      params: { page, limit, searchQuery, status }
    });
    return response.data;
  } catch (error) {
    console.error("Erro ao buscar clientes:", error);
    throw error;
  }
};

// Criação e atualização de clientes permanecem iguais
export const createCustomer = async newCustomer => {
  try {
    const response = await axios.post(API_URL, newCustomer);
    return response.data;
  } catch (error) {
    console.error("Erro ao criar cliente:", error);
    throw error;
  }
};

export const updateCustomer = async (id, updatedCustomer) => {
  console.log("CustomerService");
  console.log(updatedCustomer);
  try {
    const response = await axios.put(`${API_URL}/${id}`, updatedCustomer);
    return response.data;
  } catch (error) {
    console.error("Erro ao atualizar cliente:", error);
    throw error;
  }
};

// Novo método para listar todos os clientes com a verificação de pendências abertas em cada equipamento
export const getCustomersWithOpenPendings = async () => {
  try {
    // Esse endpoint deve retornar os clientes já com a informação de pendências abertas
    // em cada equipamento (pendências com status diferente de "consluída")
    const response = await axios.get(`${API_URL}/with-open-pendings`);
    return response.data;
  } catch (error) {
    console.error("Erro ao buscar clientes com pendências abertas:", error);
    throw error;
  }
};
